import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";

import { DialogModule } from "primeng/dialog";

import { NgStyle } from "@angular/common";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-hi-record-modal",
  standalone: true,
  imports: [DialogModule, NgStyle],
  templateUrl: "./hi-record-modal.component.html",
  styleUrl: "./hi-record-modal.component.scss",
})
export class HiRecordModalComponent implements OnInit {
  globalService = inject(GlobalService);

  @Input() record!: string;
  @Input() title: "HI1" | "HI2" = "HI1";
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  private readonly STD_CHARS_PER_LINE: number = 63;
  fontSizePx: number = 0;
  maxLength: number = 0;
  lines: string[] = [];

  recordString: string = "";

  ngOnInit(): void {
    this.formatRecord();
    this.updateFontSize();
  }

  closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  formatRecord(): void {
    this.recordString = this.record;
    this.lines = this.recordString.split("\n");
    this.maxLength = Math.min(Math.max(...this.lines.map((line) => line.length)), this.STD_CHARS_PER_LINE);
  }

  onFitToScreen(): void {
    this.updateFontSize();
  }

  onIncreaseFontSize(): void {
    if (this.fontSizePx < 17) {
      this.fontSizePx++;
    }
  }

  onDecreaseFontSize(): void {
    if (this.fontSizePx > 6) {
      this.fontSizePx--;
    }
  }

  updateFontSize(): void {
    const magicNumber = 0.51; // Constant to divide by to get optimal font size.
    const maxAutoFontSize = 16;
    const dialogMaxVw = 0.95; // Dialog max width as % vw.
    const paddingX = 16; // Mat dialog horizontal padding.

    const usableWidth = this.globalService.screenWidth() * dialogMaxVw - paddingX * 2;
    this.fontSizePx = Math.min(usableWidth / this.maxLength / magicNumber, maxAutoFontSize);
  }
}
